import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/919031654981"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
      style={{
        position: 'fixed',
        bottom: '30px',  // Original position
        right: '30px',
        background: '#25D366',
        color: '#ffffff',
        borderRadius: '50px',
        padding: '15px 25px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        boxShadow: '0 8px 25px rgba(37, 211, 102, 0.4)',
        cursor: 'pointer',
        zIndex: 999,
        textDecoration: 'none',
        transition: 'all 0.3s ease',
        animation: 'pulse 2s infinite'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-5px)';
        e.currentTarget.style.boxShadow = '0 12px 35px rgba(37, 211, 102, 0.6)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 8px 25px rgba(37, 211, 102, 0.4)';
      }}
    >
      <FaWhatsapp style={{ fontSize: '1.8rem' }} />
      <span className="d-none d-md-inline fw-semibold">Chat with us</span>

      <style jsx>{`
        @keyframes pulse {
          0%, 100% {
            box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
          }
          50% {
            box-shadow: 0 8px 35px rgba(37, 211, 102, 0.7);
          }
        }

        @media (max-width: 768px) {
          .whatsapp-float {
            bottom: 20px !important;
            right: 20px !important;
            padding: 12px 20px !important;
          }
        }

        @media (max-width: 480px) {
          .whatsapp-float {
            border-radius: 50% !important;
            padding: 15px !important;
          }
        }
      `}</style>
    </a>
  );
};

export default WhatsAppFloat;
